import { t } from '@lingui/core/macro';
import * as React from 'react';
import Icon from 'components/Icon';
import { userSession } from 'state/session';
import DealerToolsMenu from 'components/DealerToolsMenu';
import EndSessionButton from 'components/EndSessionButton';
import CopySharingLinkButton from 'components/CopyLinkButton';
import UserlaneButton from 'components/Header/UserlaneButton';
import UserMenu from './UserMenu/UserMenu';
import { ExperienceToggle } from 'containers/ExperienceSwitcher/Toggle';
import DealerIdSelectionMenu from 'components/Header/DealerIdSelection';
import { IntegrationType, integrationType } from 'utils/ui/app';

export interface IHeaderProps {
  withControls?: boolean;
  onEndSession?: () => void;
}

const Header: React.FC<IHeaderProps> = ({ withControls = false, onEndSession }) => {
  const session = userSession().useState();
  const elementRef = React.useRef<HTMLElement>(null);

  return (
    <header className="ex3d-streaming-header flex h-16 justify-between px-4 py-2" ref={elementRef} part="header">
      <aside className="flex h-full items-center">
        <Icon className="ex3d-logo mr-2 h-6 w-10" />
        <span className="ex3d-product-name">3D Exhibition</span>
      </aside>
      <div id="toolbar" data-testid="toolbar" className="flex items-center space-x-3">
        {withControls && (
          <>
            {/* Dealer tools are only shown for remote sessions. If we implement more dealer tools in the future,
                this logic may need to be refined. */}
            {session.isShared && session.sharingType === 'remote' && (
              <>
                <DealerToolsMenu popoverColor="var(--ex3d-adjunct-bg-color)" />
                <CopySharingLinkButton showSeparator={false} />
              </>
            )}
            {session.carStatus === 'ready' && <ExperienceToggle />}
          </>
        )}
        {/* This is the only control that should always show in the toolbar */}
        {userSession().endSessionButtonEnabled && (
          <EndSessionButton
            className="rounded-full bg-white"
            onEndSession={onEndSession}
            text={t({
              context: 'multibrand',
              message: `End call`,
            })}
          />
        )}
        {/* We hide these buttons in the web component case, since userlane is not supported there
            and the integrator is responsible for managing the logout & dealer id selection */}
        {withControls && integrationType() === IntegrationType.Standalone && (
          <>
            <DealerIdSelectionMenu />
            <UserlaneButton />
            <UserMenu />
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
